export const RANGE_MAP = Object.freeze({
  min: 0,
  max: 5,
  step: 0.5
});

export const SORT_MAP = Object.freeze({
  rating: {
    id: "rating",
    name: "Top rated",
    orderBy: "desc"
  },
  rating_5: {
    id: "rating_5",
    name: "Top Rated - 5 Reviews+",
    orderBy: "desc"
  },
  rating_10: {
    id: "rating_10",
    name: "Top Rated - 10 Reviews+",
    orderBy: "desc",
    selected: true
  },
  rating_20: {
    id: "rating_20",
    name: "Top Rated - 20 Reviews+",
    orderBy: "desc"
  },
  rating_30: {
    id: "rating_30",
    name: "Top Rated - 30 Reviews+",
    orderBy: "desc"
  },
  reviews: {
    id: "reviews",
    name: "Most reviewed",
    orderBy: "desc"
  }
});

export const API_URL = "//api.greenbookglobal.com/api/v1";

export const STYLES = {
  font: {
    family: "'Lato', sans-serif"
  },
  color: {
    blue: "#26a7f2",
    black: "#000",
    grey: "#c5c5c5",
    greyDark: "#757474"
  },
  screen: {
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px"
  }
};
